// src/screens/tabs/Menu/styles/menuStyles.ts
import { StyleSheet } from "react-native";
import { FlickOColors } from "./color";
import { getResponsiveSize } from "./globalStyles";

export const menuStyles = StyleSheet.create({
  foodTypeFilter: {
    flexDirection: "row",
    alignItems: "center",
    padding: getResponsiveSize(10),
    marginHorizontal: getResponsiveSize(4),
    borderRadius: getResponsiveSize(8),
    backgroundColor: FlickOColors.background.dark,
    gap: getResponsiveSize(8),
  },
  selectedFoodTypeFilter: {
    backgroundColor: `${FlickOColors.primary}15`,
  },
  quickFiltersContainer: {
    flexDirection: "row",
    alignItems: "center",
    paddingHorizontal: getResponsiveSize(16),
    paddingVertical: getResponsiveSize(12),
    backgroundColor: FlickOColors.white,
  },
  moreFiltersButton: {
    flexDirection: "row",
    alignItems: "center",
    paddingHorizontal: getResponsiveSize(12),
    paddingVertical: getResponsiveSize(6),
    borderRadius: getResponsiveSize(16),
    marginRight: getResponsiveSize(12),
    backgroundColor: `${FlickOColors.primary}10`,
  },
  moreFiltersText: {
    marginLeft: getResponsiveSize(4),
    color: FlickOColors.primary,
    fontSize: getResponsiveSize(14),
    fontWeight: "500",
  },
  filterChip: {
    flexDirection: "row",
    alignItems: "center",
    paddingHorizontal: getResponsiveSize(12),
    paddingVertical: getResponsiveSize(6),
    borderRadius: getResponsiveSize(16),
    marginRight: getResponsiveSize(8),
    backgroundColor: FlickOColors.background.dark,
  },
  selectedFilterChip: {
    backgroundColor: `${FlickOColors.primary}20`,
  },

  filterChipText: {
    fontSize: getResponsiveSize(14),
    color: FlickOColors.text.primary,
    fontWeight: "500",
  },
  // Container Styles
  container: {
    flex: 1,
    backgroundColor: FlickOColors.white,
  },
  contentContainer: {
    paddingHorizontal: getResponsiveSize(16),
  },
  imageContainer: {
    position: "relative",
    width: "100%",
    height: getResponsiveSize(200),
  },
  searchContainer: {
    flexDirection: "row",
    alignItems: "center",
    paddingHorizontal: getResponsiveSize(16),
    paddingVertical: getResponsiveSize(12),
    backgroundColor: FlickOColors.background.dark,
  },
  menuItemsContainer: {
    paddingHorizontal: getResponsiveSize(16),
  },

  // Profile Section Styles
  profileSection: {
    backgroundColor: FlickOColors.white,
    marginBottom: getResponsiveSize(16),
  },
  profileImage: {
    width: "100%",
    height: "100%",
  },
  contentWrapper: {
    padding: getResponsiveSize(16),
  },
  infoRow: {
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "flex-start",
  },
  restaurantInfo: {
    flex: 1,
  },
  cuisineContainer: {
    flexDirection: "row",
    flexWrap: "wrap",
    marginTop: getResponsiveSize(4),
  },

  // Edit Button Styles
  editButton: {
    position: "absolute",
    top: getResponsiveSize(12),
    right: getResponsiveSize(12),
    backgroundColor: "rgba(0, 0, 0, 0.7)",
    borderRadius: getResponsiveSize(8),
    padding: getResponsiveSize(12),
    flexDirection: "row",
    alignItems: "center",
    gap: getResponsiveSize(8),
  },
  editText: {
    color: FlickOColors.white,
    fontSize: getResponsiveSize(14),
    fontWeight: "500",
  },

  // Category Styles
  categoryCard: {
    marginBottom: getResponsiveSize(24),
  },
  categoryTitle: {
    fontSize: getResponsiveSize(18),
    fontWeight: "600",
    color: FlickOColors.text.primary,
    marginBottom: getResponsiveSize(16),
  },
  subCategoryContainer: {
    marginBottom: getResponsiveSize(16),
  },
  subCategoryHeader: {
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: getResponsiveSize(12),
  },
  subCategoryTitle: {
    fontSize: getResponsiveSize(16),
    fontWeight: "500",
    color: FlickOColors.text.primary,
  },

  // Menu Item Styles
  menuItemCard: {
    flexDirection: "row",
    justifyContent: "space-between",
    paddingVertical: getResponsiveSize(12),
  },
  contentSection: {
    flex: 1,
    marginRight: getResponsiveSize(16),
  },
  typeIconContainer: {
    marginBottom: getResponsiveSize(8),
  },
  foodTypeIcon: {
    width: getResponsiveSize(16),
    height: getResponsiveSize(16),
    borderWidth: 1,
    borderRadius: getResponsiveSize(8),
    justifyContent: "center",
    alignItems: "center",
  },
  vegIcon: {
    borderColor: "#008000",
  },
  eggIcon: {
    borderColor: "#FFA500",
  },
  nonVegIcon: {
    borderColor: "#FF0000",
  },
  innerDot: {
    width: getResponsiveSize(8),
    height: getResponsiveSize(8),
    borderRadius: getResponsiveSize(4),
  },
  itemImage: {
    width: getResponsiveSize(100),
    height: getResponsiveSize(100),
    borderRadius: getResponsiveSize(8),
  },
  itemName: {
    fontSize: getResponsiveSize(16),
    fontWeight: "500",
    color: FlickOColors.text.primary,
    marginBottom: getResponsiveSize(4),
  },
  price: {
    fontSize: getResponsiveSize(14),
    fontWeight: "500",
    color: FlickOColors.text.primary,
    marginBottom: getResponsiveSize(4),
  },
  description: {
    fontSize: getResponsiveSize(14),
    color: FlickOColors.text.secondary,
    marginBottom: getResponsiveSize(8),
  },

  // Filter Styles
  filterContainer: {
    flexDirection: "row",
    alignItems: "center",
    paddingHorizontal: getResponsiveSize(16),
    paddingVertical: getResponsiveSize(12),
  },
  filterButton: {
    flexDirection: "row",
    alignItems: "center",
    padding: getResponsiveSize(8),
    borderRadius: getResponsiveSize(20),
    backgroundColor: `${FlickOColors.primary}10`,
  },
  filterButtonText: {
    marginLeft: getResponsiveSize(8),
    color: FlickOColors.primary,
    fontSize: getResponsiveSize(14),
    fontWeight: "500",
  },
  activeFilterChip: {
    backgroundColor: `${FlickOColors.primary}20`,
  },

  // Rating Styles
  ratingContainer: {
    flexDirection: "row",
    alignItems: "center",
    marginBottom: getResponsiveSize(4),
  },
  ratingCount: {
    fontSize: getResponsiveSize(12),
    color: FlickOColors.text.secondary,
    marginLeft: getResponsiveSize(4),
  },
  star: {
    color: FlickOColors.success,
    fontSize: getResponsiveSize(14),
  },

  // Toggle Styles
  toggleButton: {
    flexDirection: "row",
    alignItems: "center",
    backgroundColor: FlickOColors.background.dark,
    paddingVertical: getResponsiveSize(4),
    paddingHorizontal: getResponsiveSize(8),
    borderRadius: getResponsiveSize(4),
    alignSelf: "flex-start",
  },
  toggleButtonEnabled: {
    backgroundColor: `${FlickOColors.success}10`,
  },
  toggleText: {
    marginLeft: getResponsiveSize(4),
    fontSize: getResponsiveSize(12),
    color: FlickOColors.text.secondary,
  },
  toggleTextEnabled: {
    color: FlickOColors.success,
  },

  // Utility Styles
  divider: {
    height: 1,
    backgroundColor: FlickOColors.gray.light,
    marginVertical: getResponsiveSize(12),
  },
  emptyText: {
    fontSize: getResponsiveSize(14),
    color: FlickOColors.text.secondary,
    textAlign: "center",
    marginVertical: getResponsiveSize(16),
  },
  searchInput: {
    flex: 1,
    marginLeft: getResponsiveSize(8),
    fontSize: getResponsiveSize(16),
    color: FlickOColors.text.primary,
  },
});
